import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Device_Interface } from 'src/app/Interface/Device_Interface';
import { Device_MANUFACTURE_Interface } from 'src/app/Interface/Device_MANUFACTURE_Interface';
import { Device_MPE_Interface } from 'src/app/Interface/Device_MPE_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  constructor(private http:HttpClient) { }
  GetRecord(Title:String, PeriodDate:number, StartSearchDate:String, EndSearchDate:String):Observable<Array<Device_Interface>>{
    return this.http.get(environment.BaseUrl
      + "Daro/Device?DeviceTitle="+Title
      +"&PeriodDate="+PeriodDate
      +"&StartSearchDate="+StartSearchDate
      +"&EndSearchDate="+EndSearchDate).pipe(
      map(data=>{
        return data as Array<Device_Interface>
      })
    )
  }

  GetDeviceCount():Observable<any>{
    return this.http.get(environment.BaseUrl + "Daro/Device/GetDeviceCount").pipe(
      map(data=>{
        return data as any
      })
    )
  }

  GetSingle(id:Number):Observable<any>{
    return this.http.get(environment.BaseUrl + "Daro/Device/GetSingle?id="+id).pipe(
      map(data=>{
        return data as any
      })
    )
  }

  uploadFile(body){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Device/Upload", body).pipe(
      map(data=>{

        return data
      })
    )
  }


  GetSearchCalibration(NameSearch:string,CodeSearch:string):Observable<Array<Device_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Device/GetSearchCalibration?NameSearch="+NameSearch
    +"&CodeSearch="+CodeSearch).pipe(
      map(data=>{
        return data as Array<Device_Interface>
      })
    )
  }

  GetLetterRequestCustomerCalibrationDevice(LetterId:number,InLocation:boolean):Observable<Array<Device_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Letterrequestcustomer/GetLetterRequestCustomerCalibrationDevice?LetterId="+LetterId
    +"&InLocation="+InLocation).pipe(
      map(data=>{
        return data as Array<Device_Interface>
      })
    )
  }

  AddDevice(model: Device_Interface,
    Device_File: Array<General_Interface>,
    Device_MANUFACTURE: Array<Device_MANUFACTURE_Interface>,
    Device_MPE: Array<Device_MPE_Interface>): Observable<Device_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var model2 = {
      id:model.id,
      Title:model.title,
      quantity_id:model.quantity_id,
      observation:model.observation,
      del:false,
      subdate:null
    }

    var DeviceList=[]
    var DeviceDetailList=[]

    var Indexer:number=0
    for(let item of Device_MANUFACTURE)
    {
      DeviceList.push({
        id:item.id,
        device_id:item.device_id,
        MANUFACTURE:item.mANUFACTURE,
        MODEL:item.mODEL,
        username:''
      })

      for(let itemDetail of item.detail){
        DeviceDetailList.push({
          id:itemDetail.id,
          MANUFACTURE_id:Indexer,
          RANGE_MIN:itemDetail.rANGE_MIN,
          RANGE_MAX:itemDetail.rANGE_MAX,
          RANGE_Vahed_id:itemDetail.rANGE_Vahed_id,
          RESOLUTION:itemDetail.rESOLUTION,
          RESOLUTION_Vahed_id:itemDetail.rESOLUTION_Vahed_id,
          username:''
        })
      }

      Indexer++
    }

    var DeviceMPEList = []
    for (let item of Device_MPE)
    {
      DeviceMPEList.push({
        id:item.id,
        device_id:0,
        mpe_min:item.mpe_min,
        mpe_max:item.mpe_max,
        mpe_goal:item.mpe_goal,
        mpe_sys:item.mpe_sys,
        mpe_rnd:item.mpe_rnd,
      })
    }

    var Device_File_temp = []
    for (let item of Device_File)
    {
      Device_File_temp.push({
        id:item.id,

        src:item.title,
        title:item.dsc,

      })
    }

    var body={
      model:model2,
      Device_MPE:DeviceMPEList,
      Device_MANUFACTURE:DeviceList,
      Device_MANUFACTURE_Detail:DeviceDetailList,
      files:Device_File_temp,

    }

    return this.http.post(environment.BaseUrl + "Daro/Device/Add",body,{headers}).pipe(
      map(data=>{
        return data as Device_Interface
      })
    )

  }

  EditDevice(model: Device_Interface,
    Device_MANUFACTURE: Array<Device_MANUFACTURE_Interface>,
    Device_File: Array<General_Interface>,
    Device_MPE: Array<Device_MPE_Interface>): Observable<Device_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var model2 = {
      id:model.id,
      Title: model.title,
      quantity_id: model.quantity_id,
      observation:model.observation,
      del:false,
      username:'',
      subdate:null
    }

    var DeviceList=[]
    var DeviceDetailList=[]

    var Indexer:number=0
    for(let item of Device_MANUFACTURE)
    {
      DeviceList.push({
        id:item.id,
        device_id:item.device_id,
        MANUFACTURE:item.mANUFACTURE,
        MODEL:item.mODEL,
        username:''
      })

      for(let itemDetail of item.detail){
        DeviceDetailList.push({
          id:itemDetail.id,
          MANUFACTURE_id:Indexer,
          RANGE_MIN:itemDetail.rANGE_MIN,
          RANGE_MAX:itemDetail.rANGE_MAX,
          RANGE_Vahed_id:itemDetail.rANGE_Vahed_id,
          RESOLUTION:itemDetail.rESOLUTION,
          RESOLUTION_Vahed_id:itemDetail.rESOLUTION_Vahed_id,
          username:''
        })
      }

      Indexer++
    }

    var DeviceMPEList = []
    for (let item of Device_MPE)
    {
      DeviceMPEList.push({
        id:item.id,
        device_id:0,
        mpe_min:item.mpe_min,
        mpe_max:item.mpe_max,
        mpe_goal:item.mpe_goal,
        mpe_sys:item.mpe_sys,
        mpe_rnd:item.mpe_rnd,
      })
    }

    
    var Device_File_temp = []
    for (let item of Device_File)
    {
      Device_File_temp.push({
        id:item.id,

        src:item.title,
        title:item.dsc,

      })
    }


    var body={
      model:model2,
      Device_MPE:DeviceMPEList,
      Device_MANUFACTURE:DeviceList,
      Device_MANUFACTURE_Detail:DeviceDetailList,
      files:Device_File_temp,
    }


    return this.http.post(environment.BaseUrl + "Daro/Device/Edit",body,{headers}).pipe(
      map(data=>{
        return data as Device_Interface
      })
    )

  }

  DeleteDevice(id:number):Observable<Device_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/Device/Delete?id="+id).pipe(
        map(data=>{
          return data as Device_Interface
        })
      )

  }

  GetDeviceFile(id:number):Observable<Array<General_Interface>>{

    return this.http.get(environment.BaseUrl + "Daro/Device/GetDeviceFile?id="+id).pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )

}


  GetDeviceInLetter(startDate: string,
    endDate: string,
    customer: string,
    deviceName:string): Observable<Array<any>>{
    return this.http.get(environment.BaseUrl + "Daro/Device/GetDeviceInLetter?startDate="+startDate
      + "&endDate="+endDate
      + "&customer=" + customer
      + "&deviceName=" + deviceName).pipe(
      map(data=>{
        return data as Array<any>
      })
    )
  }

}
